<form [formGroup]="editorRegistroForm" autocomplete="off">
  <mat-form-field appearance="outline" [hideRequiredMarker]="!isRequiredField">
    <mat-label>{{ label }}</mat-label>

    <input
      #inputFiltro
      matInput
      [readonly]="selectOnly"
      placeholder="{{ placeHolderTranslation }}"
      name="{{ formControlText }}"
      id="{{ formControlText }}"
      [attr.list]="idList"
      [attr.title]="editorRegistroForm?.get('answer')?.value"
      (blur)="onInputBlur()"
      (focus)="onInputFocus($event)"
      (mousedown)="onInputMouseDown($event)"
      formControlName="answer"
      (input)="OnChange()"
    />
    <mat-error *ngIf="showCampoRequeridoMatError">
      * {{ textoCampoRequerido }}
    </mat-error>
    <datalist [id]="idList">
      <option *ngFor="let item of listCopy" [attr.title]="item[dataInput]">
        {{ item[textShow] }}
      </option>
    </datalist>

    <input
      type="hidden"
      name="input"
      formControlName="answerHidden"
      id="{{ formControlText }}-hidden"
    />
  </mat-form-field>
</form>
